export const WINDOW_WIDTH_DELIMITER = 1000

const isDesktopScreenSize = () => {
    return window.innerWidth > WINDOW_WIDTH_DELIMITER
}

export default isDesktopScreenSize
